/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import styled from 'styled-components';

export const FormImageLinksContainerStyled = styled.div`
    display: flex;
    align-items: flex-end;

    && > * {
        margin-bottom: 0;
    }
    & > :first-child {
        width: 100%;
    }
    & > button {
        margin-left: 24px;
    }
`;

export const FormImageLinksAttachedList = styled.ul`
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    margin-top: 16px;
`;
